import { c as _c } from "react/compiler-runtime";
import { useWaveById } from "@/hooks/useWaveById";
import ChatItemHrefButtons from "../ChatItemHrefButtons";
import WaveItemWide from "./WaveItemWide";
export default function WaveItemChat(t0) {
  const $ = _c(10);
  const {
    href,
    waveId
  } = t0;
  const wave = useWaveById(waveId);
  let t1;
  if ($[0] !== href || $[1] !== wave.wave || $[2] !== waveId) {
    t1 = <div className="tw-min-w-0 tw-flex-1"><div className="tw-rounded-xl tw-border tw-border-solid tw-border-iron-700"><WaveItemWide wave={wave.wave} userPlaceholder={href} titlePlaceholder={waveId} /></div></div>;
    $[0] = href;
    $[1] = wave.wave;
    $[2] = waveId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = `/waves/${waveId}`;
  let t3;
  if ($[4] !== href || $[5] !== t2) {
    t3 = <ChatItemHrefButtons href={href} relativeHref={t2} />;
    $[4] = href;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <div className="tw-flex tw-w-full tw-items-stretch tw-gap-x-1">{t1}{t3}</div>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}